import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { ProfileItem } from 'qp-ui-interface';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NavigationLibraryService } from '../../services/navigation/navigation.service';
import { UserStateService } from '../../services/user-state/user-state.service';
import { SubscriptionHandlerService } from '../../services/subscription-handler.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent implements AfterViewInit, OnDestroy {
  profile: ProfileItem;
  show: boolean;
  private destroy$ = new Subject<void>();
  private componentName = 'LoadingComponent';
  constructor(
    private userState: UserStateService,
    private navService: NavigationLibraryService,
    private readonly subscriptionHandlerService: SubscriptionHandlerService
  ) {
    const loading: Subscription = this.userState.loading.pipe(takeUntil(this.destroy$)).subscribe((isLoading) => {
      this.show = isLoading;
    });
    this.subscriptionHandlerService.addSubscription(this.componentName, 'loading', loading);

    const selectedProfile: Subscription = this.userState.selectedProfile.pipe(takeUntil(this.destroy$)).subscribe((profile) => {
      this.profile = profile;
    });
    this.subscriptionHandlerService.addSubscription(this.componentName, 'selectedProfile', selectedProfile);
  }
  async ngAfterViewInit() {
    this.navService.focusContainer('profiles-list', true);
  }

  ngOnDestroy(): void {
    this.subscriptionHandlerService.unsubscribeAllFromComponent(this.componentName);
    this.destroy$.next();
    this.destroy$.complete();
  }
}
